export default __webpack_public_path__ + "static/media/preview_lowRes_videoOldMountain.502d49e5.png";